/**
 * RUSHnGO — cheap motion helpers (identical visuals).
 * - Tab-hidden class for CSS pause
 * - CSS squiggle marquees
 * - Off-screen pause for tickers + squiggles (large rootMargin so they never
 *   visibly freeze while still near the viewport)
 * - Shared pointer/scroll bus so section magnetic scripts don't each attach
 *   their own window mousemove/scroll listeners
 */
(function () {
  function syncTabHidden() {
    document.documentElement.classList.toggle('rn-tab-hidden', document.hidden);
  }

  document.addEventListener('visibilitychange', syncTabHidden);
  syncTabHidden();

  function enableCssSquiggles(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.marquee-squiggle__track').forEach(function (track) {
      track.style.transform = '';
      track.classList.add('rn-css-marquee');
    });
  }

  var OFFSCREEN_SELECTOR = [
    '.marquee-squiggle__track.rn-css-marquee',
    '.horizontal-ticker__container',
    '.header-ticker-block__track',
    '.vertical-ticker__container',
    '.sparkle-deco-svg',
    '[class*="sparkle-deco-icon"]',
  ].join(',');

  var offscreenObserver = null;

  function observeOffscreen(root) {
    if (!('IntersectionObserver' in window)) return;
    if (!offscreenObserver) {
      // Large margin: pause only when well away from viewport (no mid-scroll freeze).
      offscreenObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            entry.target.classList.toggle('rn-offscreen-paused', !entry.isIntersecting);
          });
        },
        { rootMargin: '800px 0px', threshold: 0 }
      );
    }
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(OFFSCREEN_SELECTOR).forEach(function (el) {
      if (el.dataset.rnOffscreenObs === '1') return;
      el.dataset.rnOffscreenObs = '1';
      offscreenObserver.observe(el);
    });
  }

  function boot() {
    enableCssSquiggles(document);
    observeOffscreen(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (ev) {
    var target = ev && ev.target ? ev.target : document;
    enableCssSquiggles(target);
    observeOffscreen(target);
  });
})();
